import validator from "@rjsf/validator-ajv8";
import { withTheme } from "@rjsf/core";
import { widgetDefinition } from "./Widgets/WidgetDefinition";
import { useFormSchema } from "src/api/hooks/useFormSchema";
import { ThemeStyle } from "./ThemeStyle";
import { lang } from "src/language/Strings";
import useChangeTitle from "src/api/hooks/useChangeTitle";
import { queryClient } from "src/main";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import React from "react";
import { RJSFSchema, UiSchema } from "@rjsf/utils";
import colorsJson from "../../../colors.json";
import { queryKeys } from "src/api/queryKeys";
import { FileType, SasFileResult } from "src/types/InspectionUpdateRequest";
import useFileMutation from "src/api/hooks/useFileMutation";
import { useFilesForCompanyId } from "src/api/hooks/useFiles";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { routes } from "src/routes";
const ThemedForm = withTheme(widgetDefinition);

export function SchemaForm() {
  const { data: schema } = useFormSchema();
  const queryClient = useQueryClient();
  const { data: files } = useFilesForCompanyId();
  useChangeTitle(schema?.schema.title ?? "");
  const { companyId, schemaId } = useParams();
  const [formResultId, setFormResultId] = useState<number | undefined>(
    undefined
  );
  // Merge submit button options into uiSchema
  const uiSchemaWithSubmitButton = schema?.uiSchema
    ? {
        ...schema.uiSchema,
        "ui:submitButtonOptions": {
          submitText: lang.save,
        },
      }
    : {
        "ui:submitButtonOptions": {
          submitText: lang.save,
        },
      };
  const createFileMutation = useFileMutation();
  const nav = useNavigate();
  useEffect(() => {
    if (createFileMutation.create.isSuccess) {
      queryClient.invalidateQueries({
        queryKey: queryKeys.files(companyId!, "all"),
      });
      nav(
        routes.VehicleInspection.ShowFormResult.url(
          companyId!,
          schemaId!,
          createFileMutation.create.data?.id!
        )
      );
    }
  }, [createFileMutation.create.isSuccess]);
  const formResult = useQuery({
    queryKey: ["Files", companyId!, formResultId],
    queryFn: async () => {
      const file = files?.find((f) => f.id === formResultId);
      if (file) {
        const response = await axios.get(file.files[0] || "");
        return response.data;
      }
    },
    enabled: !!formResultId,
  });
  return (
    <>
      <ThemeStyle uiSchema={schema?.uiSchema || {}} />
      <div className="flex flex-col h-full w-full p-4 overflow-x-hidden box-border">
        <div className="w-full max-w-full overflow-x-hidden box-border">
          {schema ? (
            <div
              style={{
                maxWidth: "800px",
                margin: "0 auto",
                padding: "24px",
                backgroundColor: "#ffffff",
                borderRadius: "12px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                position: "relative",
              }}
            >
              <div
                style={{
                  padding: "16px 20px",
                  backgroundColor: "#ffffff",
                  borderBottom: `3px solid ${
                    schema?.theme?.colors?.primary || "#4CAF50"
                  }`,
                  borderRadius: "8px 8px 0 0",
                  marginBottom: "24px",
                  position: "relative",
                }}
              >
                <h2
                  className="primary-text"
                  style={{
                    fontSize: "24px",
                    fontWeight: "700",
                    margin: 0,
                  }}
                >
                  {schema?.schema?.title || "Form"}
                </h2>
              </div>
              <div style={{ padding: "0" }}>
                <ThemedForm
                  key={schema.schema.title ?? "schema"}
                  schema={schema.schema}
                  validator={validator}
                  onSubmit={(e) => {
                    queryClient.invalidateQueries({
                      queryKey: ["schema", schemaId!],
                    });
                    queryClient.invalidateQueries({
                      queryKey: queryKeys.files(companyId!, "all"),
                    });
                    createFileMutation.create.mutate({
                      fileName: "form_response.json",
                      depiction: "Svar på formulär",
                      fileType: FileType.FormResponse,
                      comment: "Form response",
                      companyId: Number(companyId),
                      schemaId: schema.file.schemaId,
                      file: new File(
                        [JSON.stringify(e.formData)],
                        "form_response.json"
                      ),
                    });
                  }}
                  uiSchema={uiSchemaWithSubmitButton}
                />
                {formResultId}
              </div>
            </div>
          ) : (
            <div
              style={{
                maxWidth: "800px",
                margin: "0 auto",
                padding: "24px",
                backgroundColor: "#ffffff",
                borderRadius: "12px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
              <small className="text-PrimaryRed text-center w-full h-full flex items-center justify-center pt-10">
                No schema found
              </small>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
